import React from 'react';
import { Condition } from '../../types/dashboard';
import { FileText, CheckCircle, Clock, AlertCircle, Filter } from 'lucide-react';
interface ConditionMatrixProps {
  conditions: Condition[];
}
export function ConditionMatrix({
  conditions
}: ConditionMatrixProps) {
  return <div className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-72">
      <div className="p-5 border-b border-slate-100 flex justify-between items-center" data-id="element-73">
        <h3 className="font-bold text-slate-800 flex items-center gap-2" data-id="element-74">
          <FileText className="w-5 h-5 text-slate-500" data-id="element-75" />
          Condition Tracking Matrix
        </h3>
        <button className="flex items-center gap-2 text-sm text-slate-600 hover:text-blue-600 border border-slate-200 rounded-md px-3 py-1.5 hover:bg-slate-50" data-id="element-76">
          <Filter className="w-4 h-4" data-id="element-77" />
          Filter
        </button>
      </div>

      <div className="overflow-x-auto" data-id="element-78">
        <table className="w-full text-sm text-left" data-id="element-79">
          <thead className="bg-slate-50 text-slate-500 font-medium border-b border-slate-200" data-id="element-80">
            <tr data-id="element-81">
              <th className="px-6 py-3" data-id="element-82">Condition Name</th>
              <th className="px-6 py-3" data-id="element-83">Category</th>
              <th className="px-6 py-3" data-id="element-84">Loan ID</th>
              <th className="px-6 py-3" data-id="element-85">Aging</th>
              <th className="px-6 py-3" data-id="element-86">Status</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100" data-id="element-87">
            {conditions.map(condition => <tr key={condition.id} className="hover:bg-slate-50/50 transition-colors" data-id="element-88">
                <td className="px-6 py-4 font-medium text-slate-900" data-id="element-89">
                  {condition.name}
                </td>
                <td className="px-6 py-4" data-id="element-90">
                  <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-800" data-id="element-91">
                    {condition.category}
                  </span>
                </td>
                <td className="px-6 py-4 text-slate-600 font-mono" data-id="element-92">
                  {condition.loanId}
                </td>
                <td className="px-6 py-4" data-id="element-93">
                  <div className={`flex items-center gap-1.5 ${condition.aging > 5 ? 'text-rose-600 font-bold' : condition.aging > 2 ? 'text-amber-600' : 'text-slate-600'}`} data-id="element-94">
                    <Clock className="w-4 h-4" data-id="element-95" />
                    {condition.aging} days
                  </div>
                </td>
                <td className="px-6 py-4" data-id="element-96">
                  {condition.status === 'Pending' && <span className="inline-flex items-center gap-1.5 text-amber-600 bg-amber-50 px-2 py-1 rounded-md text-xs font-medium" data-id="element-97">
                      <AlertCircle className="w-3 h-3" data-id="element-98" /> Pending
                    </span>}
                  {condition.status === 'Review' && <span className="inline-flex items-center gap-1.5 text-blue-600 bg-blue-50 px-2 py-1 rounded-md text-xs font-medium" data-id="element-99">
                      <Clock className="w-3 h-3" data-id="element-100" /> In Review
                    </span>}
                  {condition.status === 'Cleared' && <span className="inline-flex items-center gap-1.5 text-emerald-600 bg-emerald-50 px-2 py-1 rounded-md text-xs font-medium" data-id="element-101">
                      <CheckCircle className="w-3 h-3" data-id="element-102" /> Cleared
                    </span>}
                </td>
              </tr>)}
          </tbody>
        </table>
      </div>
    </div>;
}